export const Bio = {
  name: "Cristian Gomez",
  roles: [
    "Full Stack Developer",
    "Programador",
  ],
  description:
    "Soy una persona motivada y versátil, siempre dispuesta a enfrentar nuevos desafíos. Estoy dispuesto a ofrecer resultados de alta calidad, valiendome de una actitud positiva y una mentalidad de crecimiento, estoy listo para hacer una contribución significativa y lograr grandes cosas.",
  github: "https://github.com/Cristian-Maxi",
  resume:
    "https://drive.google.com/file/d/1WJr7HDtTE9iBtE1xahqbUkHC3OOfNyqE/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
  twitter: "https://twitter.com/CristianMaxi06",
  insta: "https://www.instagram.com/cristian_maxi_gomez/",
  facebook: "https://www.facebook.com/cristian.m.gomez.90",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "TailWind",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Django",
        image:"https://lh3.googleusercontent.com/d/1XDKbiWuDjMFRLvjr0aBtlz3GsXcGNpnX"
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/7/79/Spring_Boot.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://lh3.googleusercontent.com/d/11GcNDlblZZo-4IFi_FUHiOwk6b_Jg8nU",
      },
      {
        name: "SQL Server",
        image:
          "https://logowik.com/content/uploads/images/microsoft-sql-server4529.jpg",
      },
    ],
  },
  
  {
    title: "Otros",
    skills: [
      {
        name: "Power Bi",
        image:
          "https://1000marcas.net/wp-content/uploads/2022/08/Microsoft-Power-BI-Logo-500x281.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Git",
        image:
          "https://iconape.com/wp-content/png_logo_vector/git-icon.png",
      },
      {
        name: "Docker",
        image:
          "https://lh3.googleusercontent.com/d/1Te-yc54N-ukn0QTYWZ3dBduMVQ7Pvaxf",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://cdn.worldvectorlogo.com/logos/postman.svg",
      },
      {
        name: "Excel",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/34/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg",
      },
      {
        name: "Vercel",
        image:
          "https://www.iconbolt.com/iconsets/ionicons-regular/logo-vercel.svg",
      },
    ],
  },
  {
    title: "Habilidades Blandas",
    skills: [
      {
        name: "Adaptabilidad",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
      {
        name: "Gestión del tiempo",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
      {
        name: "Comunicación",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
      {
        name: "Trabajo en equipo",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
      {
        name: "Colaboración",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
      {
        name: "Resiliencia",
        image:
          "https://www.mayugo.net/admin/images/prods/habilidades-blandas-para-desarrollo-de-personas.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://lh3.googleusercontent.com/d/1J6nJMYziTVwdAGSKKK_FevsTxbEmX9uM",
    role: "Full Stack Developer",
    company: "No Country",
    date: "Jul 2024 - Ago 2024",
    desc: "Mi primera edición en No Country, en donde elabaramos un proyecto destinado a hospitales, que tenia como finalidad el facilitar los turnos entre los pacientes y sus médicos, en este caso psicologos. En esta ocasión trabajé como back end usando el stack java-spring-mysql y tambien me desenvolví como front end, ayudando a mis compañeros con la conexión del front y el back.",
    skills: [
      "React.js",
      "Java",
      "Spring",
      "Spring Security",
      "MySQL",
      "Vercel",
      "HTML5", 
      "CSS",
      "JavaScript",
      "API de Postman",
      "Swagger",
      "Render",
      "Tailwind",
      "GitHub",
      "Git"
    ],
    doc: "https://lh3.googleusercontent.com/d/1AX9FB_z8KaApgK-dj3SfqHJog0GtTDvL",
  },
  {
    id: 1,
    img: "https://lh3.googleusercontent.com/d/1J6nJMYziTVwdAGSKKK_FevsTxbEmX9uM",
    role: "Back End Developer",
    company: "No Country",
    date: "Ago 2024 - Set 2024",
    desc: "Mi segunda participación en No Country, en donde pude trabajar junto a otros 5 compañeros de back end, 2 compañeros de front end y 1 diseñadora. En ésta oportunidad, hicimos un proyecto destinado a los refugios y adopción de mascotas. En ésta app, una persona podia ingresar con el fin de las mascotas que nuestros refugios tenian disponibles para adopción, facilitando de esta manera el proceso de adopción tanto para el interesado como para los refugios. En este proyecto me desenvolví como programador back end.",
    skills: [
      "HTML5",
      "CSS",
      "JavaScript",
      "React.js",
      "Tailwind",
      "Java",
      "Spring",
      "PostgreSQL",
      "API de Postman",
      "Docker",
      "Vercel",
      "GitHub",
      "Trello",
      "Figma",
      "Swagger",
      "GitHub",
      "Git"
    ],
    doc: "https://lh3.googleusercontent.com/d/11_tVfRSw7MCPKaXbFff4YSaMnu0lbRPf",
  },
  {
    id: 2,
    img: "https://lh3.googleusercontent.com/d/1J6nJMYziTVwdAGSKKK_FevsTxbEmX9uM",
    role: "Back End Developer",
    company: "No Country",
    date: "Set 2024 - Oct 2024",
    desc: "Mi tercera participación en No Country. En esta edición tuve la gran oportunidad de participar con un equipo de trabajo bastante solido y unido. Nuestro equipo contaba con 5 programadores back end, en donde me incluyo, 4 programadores front end, 2 diseñadoras UX/UI, 1 tester y una PM, la cual nos enseño a trabajar implementado la metodologia SCRUM, mantieniendo daylies y metas fijas para cada semana, como asi tambien implementamo TRELLO para organizar nuestra tareas y actividades.",
    skills: [
      "Trello",
      "Scrum",
      "Figma",
      "HTML5",
      "CSS",
      "JavaScript",
      "Java",
      "Spring",
      "Spring Security",
      "Map Struct",
      "MySQL",
      "Angluar",
      "TypeScript",
      "Tailwind",
      "Vercel",
      "Docker",
      "API de Postman",
      "Swagger",
      "GitHub",
      "Git",
    ],
    doc: "https://lh3.googleusercontent.com/d/16nl16TCdwjIy67Yyj4o804kvjyZL0n1Z",
  },
  {
    id: 3,
    img: "https://lh3.googleusercontent.com/d/1J6nJMYziTVwdAGSKKK_FevsTxbEmX9uM",
    role: "Back End Developer",
    company: "Hackaton Waki 2° Puesto",
    date: "Oct 2024 - Nov 2024",
    desc: "Fui uno de los 45 elegidos entre muchos, para formar 1 de los 5 equipos con el fin de participar en el Hackaton de No country para una empresa “WAKI”, en donde realizamos una App de futbol con la implementación de un sistema de apuestas en tiempo real en donde se pueden hacer preddiciones y ganar tokens de acuerdo a los resultados de los partidos y rendimientos de los jugadores. En esta ocasión trabajé como Back end junto a 1 PM, 1 BackEnd, 2 Front End, 2 UX/UI, 1 QA, 1 TL y 1 Product Owner.",
    skills: [
      "React.js",
      "Java",
      "Spring",
      "Spring Security",
      "MySQL",
      "Vercel",
      "HTML5", 
      "CSS",
      "JavaScript",
      "API de Postman",
      "Manejos de APIS",
      "Figma",
      "Swagger",
      "Render",
      "Tailwind",
      "GitHub",
      "Git"
    ],
    doc: "https://lh3.googleusercontent.com/d/18vrSnQvLxzRqs7B3ikExNEbDQhW5tpg5",
  },
  {
    id: 4,
    img: "https://lh3.googleusercontent.com/d/1J6nJMYziTVwdAGSKKK_FevsTxbEmX9uM",
    role: "Full Stack Developer",
    company: "Hackaton Open Lab 1° Puesto",
    date: "Nov 2024 - Dic 2024",
    desc: "Mi equipo resultó ganador del Hackaton de OpenLab en donde me desenvolví com Back End y brinde apoyo al Front. El proyecto consistía en una plataforma en la que las personas ayudan a crear startups de manera colaborativa, y que se conviertan en co-propietarios de los proyectos a través de tokens enlazados a la propiedad intelectual, y que opera como un fondo de inversión descentralizado gestionado bajo un protocolo que promueve la transparencia, la meritocracia y la gestión de riesgos.",
    skills: [
      "React.js",
      "Redux",
      "Java",
      "Spring",
      "Spring Security",
      "MySQL",
      "Vercel",
      "HTML5", 
      "CSS",
      "JavaScript",
      "API de Postman",
      "Manejo de APIS",
      "Figma",
      "Swagger",
      "Render",
      "Tailwind",
      "GitHub",
      "Git",
      "Docker",
      "Auth0"
    ],
    doc: "https://lh3.googleusercontent.com/d/1yd4rDA_FhpN1SDirp8lN0fgP-VMkW6HS",
  }
];

export const education = [
  {
    id: 0,
    img: "https://lh3.googleusercontent.com/d/1PEGXJk14ZXPwEnH6rST5A0PXZ0jrkUnq",
    school: "Argentina Programa 4.0 FIUBA",
    date: "Abr 2023 - Oct 2023",
    desc: "Aptitudes: JavaScript · Django REST framework · GitHub · MySQL · Django · HTML5 · Bootstrap · Next.js · Python · Hojas de estilos en cascada (CSS) · Programación orientada a objetos (POO) · React.js",
    degree: "Programador Web Full Stack",
  },
  {
    id: 1,
    img: "https://lh3.googleusercontent.com/d/1zSumY0VRnWLK8_FaAbnhRLmS2S8nkA17",
    school: "ITMaster Academy",
    date: "Jul 2023 - Dic 2023",
    desc: "Aptitudes: Cruds · NPM · JavaScript · Svelte · Babel.js · GitHub · Node.js · Angular · HTML5 · Bootstrap · Express.js · Firebase · Hojas de estilos en cascada (CSS) · Vue.js · React.js",
    degree: "Full Stack Developer",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ53UxXBi5PQuCa0e4aFOkS6L7RsY1WDufFsGs11qN1KfvTv_EPD4y6pghSTdGD0oDneg&usqp=CAU",
    school: "Fundación Carlos Slim",
    date: "Jun 2023 - Oct 2023",
    desc: "Aptitudes: Bases de datos · SQL · Optimización para motores de búsqueda (SEO) · JavaScript · PHP · Diseño web · Responsive · Logica de programacion · Experiencia de usuario · HTML5 · Herramientas de diseño · Hojas de estilos en cascada (CSS) · Programación orientada a objetos (POO)",
    degree: "Desarrollador Front End - Back End",
  },
  {
    id: 3,
    img: "https://user-images.githubusercontent.com/83146564/137408912-013f0d0c-37d1-4dc2-a1b5-77356c1003f3.png",
    school: "Codo a Codo",
    date: "Jul 2023 - Dic 2023",
    desc: "Aptitudes: JavaScript · Java · GitHub · MySQL · HTML5 · Bootstrap · Hojas de estilos en cascada (CSS) · Spring · Programación orientada a objetos (POO)",
    degree: "Full Stack Developer Java",
  },
  {
    id: 4,
    img: "https://plataforma.academiacimneiber.com/pluginfile.php/1/theme_moove/logo/1687457325/LOGO_Academia%20color%20op%20B.png",
    school: "Academia CIMNE-IBER",
    date: "Mar 2023 - Jul 2023",
    desc: "Aptitudes: Tkinter · Programación lógica · GitHub · Python · Programación orientada a objetos (POO)",
    degree: "Introducción a la Programación con Python",
  },
  {
    id: 5,
    img: "https://upload.wikimedia.org/wikipedia/commons/9/97/Coursera-Logo_600x600.svg",
    school: "Coursera",
    date: "Ene 2023 - Jul 2023",
    desc: "Aptitudes: SQL · R · Microsoft Excel · Microsoft Power BI · Análisis de datos",
    degree: "Análisis de Datos de Google",
  },
  {
    id: 6,
    img: "https://lh3.googleusercontent.com/d/1YtGzxEXwvIOukDU6jzhF5LkzhqgiAs2o",
    school: "Centro Universitario de Idiomas",
    date: "Jul 2023 - Set 2023",
    desc: "Aprobó el Nivel 8 de Ingles General para Desarrolladores de Software del Centro Universitario de Idiomas, B1.2 del Marco Comun Europeo de Referencia para las Lenguas - MCR, dentro del plan Argentina Programa 4.0",
    degree: "Ingles B1.2",
  },
  {
    id: 7,
    img: "https://lh3.googleusercontent.com/d/1DNFoIwCeRBVnttVb0VQNfUxXcXHwppTa",
    school: "Alura-Latam",
    date: "Ene 2024 - Mayo 2024",
    desc: "Aptitudes: Java · Java Servlet · Hibernate · Spring MVC · Spring · Spring Security · Spring Boot · JPA · MySQL · PostgreSQL · API de Postman · Desarrollo de API · Cruds",
    degree: "Desarrollador Back End Java",
  },
  {
    id: 8,
    img: "https://lh3.googleusercontent.com/d/1I0r0a3mg9DuVs02uKbYPTxhV_NCwA-Ya",
    school: "Cilsa ONG",
    date: "Oct 2024 - Dic 2024",
    desc: "Aptitudes: HTML5 · Hojas de estilos en cascada (CSS) · JavaScript · Node.js · Express.js · React · Bootstrap · MongoDB · MySQL",
    degree: "Full Stack Developer",
  },
  {
    id: 9,
    img: "https://lh3.googleusercontent.com/d/1JoD2b_aV2TBKDdiJJ3vwlZt8kFWH_IFA",
    school: "Bootcamp Java MindHub/Accenture",
    date: "Ene 2025 - Ene 2025",
    desc: "Aptitudes: Java 17 · Spring Boot · Spring Security · JSON Web Token · H2 · JUnit · Mockito · Microservicios · Rest Template · JPA · RabbitMQ · Swagger · Postman",
    degree: "Java Developer",
  },

];

export const projects = [
  {
    id: 9,
    title: "Pagina React Django",
    date: "Nov 2023 - Dic 2023",
    description:
      "Pagina Full Stack usando React para la parte Front End y Python, Django y MySQL para la parte Back End. El usuario podrá crear Post en la sección Blog de acuerdo a un sistema de autenticación el cual definirá su rol ya sea como editor o como un adminstrador.",
    image:
      "https://lh3.googleusercontent.com/d/1F9G4hmc4l23QrhzXvMDEDc0spNVm0E9b",
    tags: [
      "Bootstrap",
      "React.js",
      "HTML5",
      "CSS",
      "Python",
      "Django",
      "Javascript",
      "MySQL",
      "Postman",
      "Tailwind",
      "Typescript",
      "Redux",
    ],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Django-React-Page",
    webapp: "https://django-react-page-fullstack.vercel.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 0,
    title: "Ciudad de Salta",
    date: "Set 2023 - Dic 2023",
    description:
      "Página echa como proyecto final del cursado de Codo a Codo. El Front End fue echo con HTML, CSS, Javascript y Bootstrap, y la parte Back End fue echa usando java, hibernate y MySQL.",
    image:
      "https://lh3.googleusercontent.com/d/1Ht2IQoiyhTZguCvkoxVpM4AWysp7o9k5",
    tags: ["HTML5", "CSS", "Javascript", "Bootstrap", "MySQL", "Java", "JDBC", "Hibernate"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Proyecto-Final-Java",
    webapp: "https://cristian-maxi.github.io/Proyecto-Java/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 1,
    title: "Cripto Master App",
    date: "Ene 2023 - Jul 2023",
    description:
      "Página echa con HTML, CSS, Javascript y Bootstrap, simulando una página dedicada a la venta de una aplicación de trading de criptomnodas.",
    image:
      "https://lh3.googleusercontent.com/d/17z8hRao_YXyJC9zPmd-xJzCeOrH1XxJz",
    tags: [
      "HTML5",
      "CSS",
      "Javascript",
      "Bootstrap",
      "Font Awesome"
    ],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Crypto-Master-App",
    webapp: "https://main--cristian-maxi-gomez.netlify.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 2,
    title: "Lista de Tareas",
    date: "Ago 2023 - Oct 2023",
    description:
      "Página echa como proyecto final del cursado de Argentina Programa 4.0. La parte Front End fue echa Con Next.js y la parte Backend fue echa con Python, Django y MySQL. Consiste en un Login, en donde el usuario podrá ser redirigido para crear una cuenta o ingresar si ya la tiene, a una página donde el usuario puedo usar una app para guardar tareas.",
    image:
      "https://lh3.googleusercontent.com/d/1Mwt5YKuTypEFvHZhLIsCv5oWJqs7FGu5",
      tags: [
        "Bootstrap",
        "Next.js",
        "HTML5",
        "CSS",
        "Python",
        "Django",
        "Javascript",
        "MySQL",
        "Postman",
      ],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Full-Stack-Page-ARG-Programa",
    webapp: "https://next-project-git-main-cristian-maxi.vercel.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 3,
    title: "Aplicación de Clima",
    date: "Nov 2023 - Nov 2023",
    description:
      "Pequeña aplicación de pronostico de pronostico del tiempo llevada a cabo usando React.js y una Api de pronosticos la cual nos devuelve los pronostico de las 3 horas siguientes.",
    image:
      "https://lh3.googleusercontent.com/d/1YWbBYVrlTBL5I8jEm9tkQlS9oVVtsrYM",
    tags: ["HTML5","CSS","Javascript","React.js","Bootsrap", "Apis"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/app-de-clima-react",
    webapp: "https://app-de-clima-react-ntg8.vercel.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 10,
    title: "Aplicación de Presupuestos",
    date: "Set 2023 - Set 2023",
    description:
      "Aplicacón para llevar una lista de presupuestos y hacer los calculos correspondientes a los Ingresos y Egresos que se llevan a cabo. Fue echa con HTML5, CSS, Javascript y Boostrap.",
    image:
      "https://lh3.googleusercontent.com/d/1Ap2Wv7_K15dRo03k2J93HMCuuTABKIva",
    tags: ["HTML5", "CSS", "Javascript", "Bootstap", "POO"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Aplicacion-Web-Presupuesto",
    webapp: "https://cristian-maxi.github.io/Aplicacion-Web-Presupuesto/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 4,
    title: "Control de Clientes",
    date: "Nov 2023 - Dic 2023",
    description:
      "Aplicación para llevar un control de los clientes y las compras que estos llevaron a cabo, asi tambien como el total de dinero que se recaudo con estas compras. Esta fue echa con HTML5, CSS, Javascript y Boostrap en la parte front end y Java, JDBC y MySQL para el Back End.",
    image:
      "https://lh3.googleusercontent.com/d/1ebgrMFJi0_80pxk-4Q8fExxxJG_AFuRQ",
    tags: ["HTML5", "CSS", "Javascript", "Bootstap", "Java", "JDBC", "MySQL"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Java-Control-Clientes",
    webapp: "",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 5,
    title: "App de Destino Culinario",
    date: "Jun 2023 - Jul 2023",
    description:
      "Proyecto Final llevado a cabo para el cursado de Python en CIMNE-IBER, el cual consiste en una aplicación de destinos culinarios. Fue echa usnado Python y Tkinter",
    image:
      "https://lh3.googleusercontent.com/d/1X3O1YqFbdWModk98dsIliMU93nxgpySM",
    tags: ["Python", "Tkinter", "POO"],
    category: "otros",
    github: "https://github.com/Cristian-Maxi/Proyecto-Python-Destino-Culinario",
    webapp: "",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 6,
    title: "Encriptador",
    date: "Ene 2024 - Ene 2024",
    description:
      "Un encriptador de texto realizado durante el cursado de Oracle-Alura para el Desafio número 1",
    image:
      "https://lh3.googleusercontent.com/d/1eqzEwk2ToWiLszpe1nWxuNWY9nGC3Sjw",
    tags: ["HTML5", "CSS", "Javascript"],
    category: "otros",
    github: "https://github.com/Cristian-Maxi/Encriptador",
    webapp: "https://cristian-maxi.github.io/Encriptador/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 7,
    title: "Reloj Digital",
    date: "Ago 2023 - Ago 2023",
    description:
      "Un pequeño reloj digital echo con HTML5, CSS, Javascript y Bootsrap",
    image:
      "https://lh3.googleusercontent.com/d/171v5JnnKUYxL6GsGk8LT-4IY4n5VaQrU",
    tags: ["HTML5", "CSS", "Javascript", "Bootstap"],
    category: "otros",
    github: "https://github.com/Cristian-Maxi/Reloj-Digital",
    webapp: "https://cristian-maxi.github.io/Reloj-Digital/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
    {
    id: 8,
    title: "Conversor de Monedas",
    date: "Abr 2024 - Abr 2024",
    description:
      "Conversor de Monedas para el Desafio Back-End de Oracle Alura Latam. Lo realicé aplicando React para el Front End y Spring para el manejo del Back End. Puede demorar un poco durante el primer uso debido al uso de un servidor de alojamiento gratuito.",
    image:
      "https://lh3.googleusercontent.com/d/1nL67J-2FnE4NafAj2UBG7rHexwzG9J2e",
    tags: ["HTML5", "CSS", "Javascript", "Bootstap", "React.js", "Spring", "Tailwind"],
    category: "otros",
    github: "https://github.com/Cristian-Maxi/ConversorMonedasOracle/tree/main",
    webapp: "https://conversor-monedas-oracle-2ekj-omega.vercel.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
    {
    id: 11,
    title: "Crud-Empleados",
    date: "Abr 2024 - Abr 2024",
    description:
      "Crud de Empleados realizado con React y Bootstrap en el Front End y Node-Express-MySQL en el Back End.",
    image:
      "https://lh3.googleusercontent.com/d/1nJeh1scMopkGTDnkCBgLWVdGp8nzX03G",
    tags: ["Javascript", "Bootstap", "React.js", "Node.js", "Express", "MySQL"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/ConversorMonedasOracle/tree/main",
    webapp: "https://www.youtube.com/watch?v=EnClXHyD0aQ",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
      {
    id: 12,
    title: "Codo a Codo - Movies",
    date: "Ene 2024 - Feb 2024",
    description:
      "Integrador Final Front-End para el cursado de Codo a Codo 2024 - JAVA",
    image:
      "https://lh3.googleusercontent.com/d/1ko_BN1DpRdqNMNpHIyvPb3uotqtwh9TN",
    tags: ["Javascript", "Bootstrap", "HTML", "CSS"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/CaC-Movies",
    webapp: "https://cristian-maxi.github.io/CaC-Movies/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
      {
    id: 13,
    title: "Health-Care",
    date: "May 2024 - Jun 2024",
    description:
      "Mi primera participación en No Country, en donde elabaramos un proyecto destinado a hospitales, que tiene como finalizad el facilitar los turnos entre los pacientes y sus médicos, en este caso psicologos. En esta ocasión trabajé como back end usando el stack java-spring-mysql y tambien me desenvolví como front end, ayudando a mis compañeros con la conexión del front y el back.",
    image:
      "https://lh3.googleusercontent.com/d/18eqIEhMQlNv76-w_NcZaJ_7LXZVpV2L_",
    tags: ["Javascript", "HTML", "CSS", "React.js", "Tailwind CSS", "Java", "Spring", "Postman", "MySQL", "Docker", "Vercel", "Trello", "Figma", "Swagger", "GIT"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/Health-Care",
    webapp: "https://github.com/Cristian-Maxi/Health-Care",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
      {
    id: 14,
    title: "Pet-Connect",
    date: "Jun 2024 - Jul 2024",
    description:
      "Mi segunda participación en No Country, en donde pude trabajar junto a otros 5 compañeros de back end, 2 compañeros de front end y 1 diseñadora. En ésta oportunidad, hicimos un proyecto destinado a los refugios y adopción de mascotas. En ésta app, una persona podia ingresar con el fin de las mascotas que nuestros refugios tenian disponibles para adopción, facilitando de esta manera el proceso de adopción tanto para el interesado como para los refugios. En este proyecto me desenvolví como programador back end.",
    image:
      "https://lh3.googleusercontent.com/d/15KiEn8CQObmBDVWLQmh1_2s7FU3ekFSm",
    tags: ["Javascript", "HTML", "CSS", "React.js", "Tailwind CSS", "Java", "Spring", "Postman", "ModelMapper", "PostreeSQL", "Docker", "Vercel", "Trello", "Figma", "Swagger", "GIT"],
    category: "appweb",
    github: "https://github.com/No-Country-simulation/s16-02-ft-java-react/tree/main",
    webapp: "https://petconnect-nocountry.vercel.app/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
      {
    id: 15,
    title: "ForEdu",
    date: "Ago 2024 - Sept 2024",
    description:
      "Mi tercera participación en No Country. En esta edición tuve la gran oportunidad de participar con un equipo de trabajo bastante solido y unido. Nuestro equipo contaba con 5 programadores back end, en donde me incluyo, 4 programadores front end, 2 diseñadoras UX/UI, 1 tester y una PM, la cual nos enseño a trabajar implementado la metodologia SCRUM, mantieniendo daylies y metas fijas para cada semana, como asi tambien implementamo TRELLO para organizar nuestra tareas y actividades. Fue una gran experiencia el trabajar de esta forma. En cuanto al proyecto, en esta ocasión nos comprometimos en desarrollar una herramienta que proporcione información de las diferentes actividades escolares para que pueda ser manejada de forma intuitiva tanto por los padres/tutores como por el personal educativo.",
    image:
      "https://lh3.googleusercontent.com/d/1OBVC1MLQvGetgseytPSxFsUlUvAzV_qh",
    tags: ["Javascript", "HTML", "CSS", "Angular", "TypeScript", "Tailwind CSS", "Java", "Spring", , "Postman", "MySQL", "Docker", "JavaScript", "Trello", "Swagger", "MapSruct", "SCRUM", "GIT"],
    category: "appweb",
    github: "https://github.com/No-Country-simulation/s17-10-n-java-angular/tree/main",
    webapp: "https://test.zilibro.com/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
      {
    id: 16,
    title: "Cilsa Eccomerce",
    date: "Sept 2024 - Oct 2024",
    description:
      "Este proyecto se hizo como parte de la Beca de Programador Full Stack otorgada por 'CILSA - ONG por la Inclusión'. La aplicación consiste en una web destinada a la compra de productos electronicos 'gamers', creada usando HTML, CSS, Javascript y Bootstrap por ahora. Continuaremos expandiendo este proyecto constantemente con la finalidad de crear un proyecto Full Stack.",
    image:
      "https://lh3.googleusercontent.com/d/1L84S3UcpoC8sjoIFkIS8xpzmZMb4QWq_",
    tags: ["Javascript", "HTML", "CSS", "Bootstrap", "GIT", "Git-Hub", "Trello"],
    category: "appweb",
    github: "https://github.com/Cristian-Maxi/CILSA-Eccomerce",
    webapp: "https://cristian-maxi.github.io/CILSA-Eccomerce/",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
    ],
  },
  {
    id: 17,
    title: "Hackaton WAKI",
    date: "Sept 2024 - Oct 2024",
    description:
      "Waki es una plataforma orientada a los fanáticos del fútbol, diseñada para que los usuarios participen en una experiencia de predicciones deportivas, acumulen puntos y tengan la oportunidad de ganar premios y tokens.",
    image:
      "https://lh3.googleusercontent.com/d/17Sp_03iIyXz26ZrTihTPRk-hHTvQ5rJH",
    tags: ["React.js","Java","Spring","Spring Security", "MySQL", "Vercel", "HTML5", "CSS","JavaScript","API de Postman", "Manejos de APIS","Figma", "Swagger","Render","Tailwind","GitHub","Git"],
    category: "appweb",
    github: "https://github.com/No-Country-simulation/h2-02-ft-java-react/tree/main",
    webapp: "https://www.youtube.com/watch?v=HcOgbXkLETA",
    member: [
      {
        name: "Cristian Gomez",
        img: "https://avatars.githubusercontent.com/u/134754887?v=4",
        linkedin: "https://www.linkedin.com/in/cristian-gomez-montenegro/",
        github: "https://github.com/Cristian-Maxi",
      },
      {
        name: "Nahuel Rocha",
        img: "https://avatars.githubusercontent.com/u/122326935?v=4",
        linkedin: "https://www.linkedin.com/in/rocha-nahuel/",
        github: "https://github.com/NahuelRocha",
      },
      {
        name: "Marcos Travaglini",
        img: "https://avatars.githubusercontent.com/u/70725851?v=4",
        linkedin: "https://www.linkedin.com/in/marcos-travaglini/",
        github: "https://github.com/Blackpachamame",
      },
      {
        name: "Jhonny Rosero",
        img: "https://avatars.githubusercontent.com/u/72477825?v=4",
        linkedin: "https://www.linkedin.com/in/mateok13/",
        github: "https://github.com/mateok13",
      }
    ],
  },
  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
